import useReportGenerateState from '../hooks/useReportGenerateState';
import { Stack } from '@mui/material';
import { PDFReportForm } from './PDFReportForm';
import { useOutletContext } from 'react-router';
import { useTemplateState } from '../context/templateContext';
import { useResponsive } from 'src/hooks/useResponsive';
type OutletContextType = {
  title: string;
  disableHeaderFormBuilder: boolean;
  reportType: string;
  disableActions: boolean;
  setDisableActions: React.Dispatch<React.SetStateAction<boolean>>;
};
const PDFReportPage = () => {
  const { title, disableActions, setDisableActions, reportType } =
    useOutletContext<OutletContextType>();
  const isTablet = useResponsive('down', 'lg');
  const { handleReportsGenerate } = useReportGenerateState({
    setDisableActions,
  });
  const { undoChanges } = useTemplateState();

  return (
    <Stack
      flexDirection={isTablet ? 'column' : 'row'}
      gap="24px"
      flex="1"
      sx={{
        alignItems: 'flex-start',
      }}
    >
      <PDFReportForm
        title={title}
        onUndo={undoChanges}
        disableActions={disableActions}
        onSubmit={handleReportsGenerate}
        reportType={reportType}
      />
    </Stack>
  );
};

export default PDFReportPage;
